// extracted by mini-css-extract-plugin
export default {"container":"AssetItemCategories_container__w32zs"};